import angular from 'angular'
import metaBodyComponent from './metabody.component'

export default angular
  .module('ellipsis.metaBody', [])
  .component('metaBody', metaBodyComponent)
